import { useContext } from "react";
import { Container } from "reactstrap";

//Common
import FormBackGround from "../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../common/Forms/FormHeader/FormHeader";
import DisplayData from "../../common/DisplayData/DisplayData";
import ActionBar from "../../common/ActionBar/ActionBar";
import BlockIcon from "../../common/Icons/BlockIcon";
import ActivateIcon from "../../common/Icons/ActivateIcon";
import { Button } from "../../common/VFX-UI";

//App
import { StatesContext } from "./StatesContainer";
import useComponentGeneralStyles from "../../styles";
import { EMPTY_GUID } from "../../../utility/constants";
import useStateStyles from "./styles";
import { StateViewProps } from "../../../types/state";

const StateView = (props: StateViewProps) => {
  const {
    onClose,
    editAction,
    toggleActivateHandler,
    toggleDeactivateHandler,
  } = props;
  const stateContext = useContext(StatesContext);
  const generalStyles = useComponentGeneralStyles();
  const stateStyles = useStateStyles();

  const state = stateContext?.data;

  const selectedRegion = stateContext?.lookupsData?.find(
    (option: { id: string | null | undefined }) => option.id === state?.regionId
  );

  return (
    <FormBackGround>
      <FormHeader
        title="View State"
        chipLabel={state?.isActive ? "Active" : "Inactive"}
        onClose={onClose}
        editActionHandler={editAction}
      />
      <Container>
        <DisplayData text="Name" importedData={state?.name}></DisplayData>
        <DisplayData
          text="Description"
          importedData={state?.description}
        ></DisplayData>
        <DisplayData
          text="Abbreviation"
          importedData={state?.abbreviation}
        ></DisplayData>
        <DisplayData text="Capital" importedData={state?.capital}></DisplayData>
        {selectedRegion !== undefined && selectedRegion && (
          <DisplayData
            text="Region"
            importedData={selectedRegion.name}
          ></DisplayData>
        )}

        {state?.id && state?.id !== EMPTY_GUID && state?.isActive && (
          <Container>
            <Button
              style={generalStyles.deleteButton}
              onClick={toggleDeactivateHandler}
            >
              <BlockIcon />
            </Button>
          </Container>
        )}
        {state?.id && state?.id !== EMPTY_GUID && !state?.isActive && (
          <Container>
            <Button
              style={generalStyles.activateButton}
              onClick={toggleActivateHandler}
            >
              <ActivateIcon />
            </Button>
          </Container>
        )}
      </Container>
      <Container style={stateStyles.actionBarContainer}>
        <ActionBar cancelHandler={onClose} cancelText="Close"></ActionBar>
      </Container>
    </FormBackGround>
  );
};

export default StateView;
